import Markdown from "./markdown"
import AuthItem from "./auth-item"
import parameters from "./parameters"
import VersionStamp from "./version-stamp"
import OnlineValidatorBadge from "./online-validator-badge"
import Model from "./model"

export default {
  Markdown,
  AuthItem,
  parameters,
  VersionStamp,
  model: Model,
  onlineValidatorBadge: OnlineValidatorBadge,
}



// WEBPACK FOOTER //
// ./src/core/plugins/oas3/wrap-components/index.js